// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import postCampaignEntity from './entities/post-campaign.json';
import postCampaignMenu from '../pages/post-campaign/menu.json';
import postCampaignFullForm from '../pages/post-campaign/forms/full.json';
import postCampaignContextForm from '../pages/post-campaign/forms/context.json';
import postCampaignMiniForm from '../pages/post-campaign/forms/mini.json';
import postCampaignLookupForm from '../pages/post-campaign/forms/lookup.json';
import postCampaignTableView from '../pages/post-campaign/views/table.json';
import postCampaignDashboardView from '../pages/post-campaign/views/dashboard.json';

/** Тип запису «Кампанія допису» зі сторінками пакета: меню, форми та подання з pages/post-campaign/. */
export const postCampaignDefinition: IRecordTypeDefinition = {
  ...postCampaignEntity,
  views: assembleViewSet({
      table: postCampaignTableView,
      dashboard: postCampaignDashboardView,
  }),
  form: postCampaignFullForm,
  forms: { full: postCampaignFullForm, context: postCampaignContextForm, mini: postCampaignMiniForm, lookup: postCampaignLookupForm },
  menu: postCampaignMenu,
} as IRecordTypeDefinition;
